import '../lib_shim.js';
import '../../js_src/js/dol/basics.js';
import '../../js_src/js/external/velocity.including.ui.min.js';
import '../../js_src/js/shared/external_link.js';
import '../../js_src/js/shared/header_menu.js';
import '../../js_src/js/external/hammer.min.js';
import '../../js_src/js/dol/mobile.js';
import '../../js_src/js/shared/web_components/plp.js';
import '../../js_src/js/shared/web_components/button.js';
import '../../js_src/js/shared/web_components/link_button.js';
import '../../js_src/js/shared/web_components/inline_message.js';